import React, { useState } from "react";
import cx from "classnames";
import styles from "./FAQs.module.scss";
// import Image from "@components/Image";
import Icons from "@gstyles/styleguide/icons";

interface Props {
  data: {
    title: string;
    content: string | React.ReactNode;
  };
}

export default function Item({ data }: Props) {
  const [expand, setExpand] = useState(false);

  return (
    <div className={cx(styles.item)}>
      <div
        className={cx(
          styles.title,
          expand ? styles.expanded : styles.borderTopTitle
        )}
        onClick={() => setExpand(!expand)}
      >
        <div>{data.title}</div>
        <Icons
          name="arrow-long-narrow-right"
          color="#AF915E"
          className={cx(styles.arrowIcon)}
        />
      </div>
      <div
        className={cx(styles.contentWrapper, {
          [styles.expandedContentWrapper]: expand,
        })}
      >
        <div className={cx(styles.content)}>{data.content}</div>
      </div>
    </div>
  );
}
